<header>
  <img alt="logo" src="assets/icon/profile.svg" />
  <span class="title">Dashboard</span>
  <ul class="nav-bar">
    @for (item of navItems(); track item) {
      <li>
        <a data-testid="nav-bar-item" [href]="item.uri">{{ item.name }}</a>
      </li>
    }
  </ul>
  <span class="name" data-testid="name">{{ user() }}</span>
  <button
    class="logout button"
    data-testid="logout-button"
    (click)="logout.emit()"
  >
    <fa-icon [icon]="faRightFromBracket" />Uitloggen
  </button>
</header>
